"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTranslationResources = exports.renderReactComponentsInsideElementsIfNeeded = void 0;
var client_side_hydrater_1 = require("./client-side-hydrater");
Object.defineProperty(exports, "renderReactComponentsInsideElementsIfNeeded", { enumerable: true, get: function () { return client_side_hydrater_1.renderReactComponentsInsideElementsIfNeeded; } });
Object.defineProperty(exports, "getTranslationResources", { enumerable: true, get: function () { return client_side_hydrater_1.getTranslationResources; } });
//# sourceMappingURL=index.js.map